import { useNotificationEmails } from '@/modules/emails/hooks/useNotificationEmails'
import { NotificationEmailsList } from '@/modules/emails/components/NotificationEmailsList'
import { EmailCatalog } from '@/modules/emails/components/EmailCatalog'
import { ErrorState } from '@/shared/components/ui/atoms/ErrorState'

export function EmailsPage() {
  const { data: emails, isLoading, error, refetch } = useNotificationEmails()

  return (
    <div className="max-w-3xl">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Emails</h1>

      {/* Section 1: Notification Emails List */}
      <div className="card p-6 mb-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">
          Emails de notificación actuales
        </h2>
        <p className="text-sm text-gray-500 mb-4">
          Estos correos reciben notificaciones cuando se acumulan, canjean o devuelven puntos.
          Puedes editarlos desde la sección de Configuración.
        </p>

        {error ? (
          <ErrorState message={error} onRetry={refetch} />
        ) : (
          <NotificationEmailsList emails={emails} isLoading={isLoading} />
        )}
      </div>

      {/* Section 2: Email Catalog - All transactional emails */}
      <div className="card p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-2">
          Catálogo de emails del sistema
        </h2>
        <p className="text-sm text-gray-500 mb-4">
          Listado de todos los emails que la aplicación envía. Usa el toggle para activar o
          desactivar cada tipo de email. Puedes enviar emails de prueba con datos de ejemplo
          para verificar su contenido.
        </p>
        <EmailCatalog />
      </div>
    </div>
  )
}
